<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Sales Target Information
    </div>
    <div class="enterprise-network_container">
      <el-form ref="form" :model="formData" :rules="rules" label-position="top" :disabled="!isSeniorEditor">
        <div class="enterprise-network_grid grid-1x2 gap_80" v-if="partnerType === 'RAD'">
          <el-form-item prop="rebateCoefficient">
            <template #label>
              <div class="enterprise-network-label">
                Sales Target Rebate Ratio
              </div>
            </template>
            <el-input
              v-model="formData.rebateCoefficient"
              placeholder="Please enter"
            />
          </el-form-item>
          <!--2024-02-28要求隐藏-->
          <!--<el-form-item prop="mboRebateRatio">-->
          <!--  <template #label>-->
          <!--    <div class="enterprise-network-label">-->
          <!--      MBO Rebate Ratio-->
          <!--    </div>-->
          <!--  </template>-->
          <!--  <el-input-->
          <!--    v-model="formData.mboRebateRatio"-->
          <!--    placeholder="Please enter"-->
          <!--  />-->
          <!--</el-form-item>-->
        </div>
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item>
            <template #label>
              <div class="enterprise-network-label">
                Total Sales Target (USD)
              </div>
            </template>
            <div class="enterprise-network_value">{{ toThousands(assignment) }}</div>
          </el-form-item>
        </div>
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item>
            <template #label>
              <div class="enterprise-network-label_required">
                Quarterly Target (USD)
              </div>
            </template>
            <div class="enterprise-network_grid grid-1x4 gap_6">
              <el-form-item prop="saleTargetQ1" label="Q1">
                <el-input-number
                  v-model="formData.saleTargetQ1"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="Q1"
                />
              </el-form-item>
              <el-form-item prop="saleTargetQ2" label="Q2">
                <el-input-number
                  v-model="formData.saleTargetQ2"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="Q2"
                />
              </el-form-item>
              <el-form-item prop="saleTargetQ3" label="Q3">
                <el-input-number
                  v-model="formData.saleTargetQ3"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="Q3"
                />
              </el-form-item>
              <el-form-item prop="saleTargetQ4" label="Q4">
                <el-input-number
                  v-model="formData.saleTargetQ4"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="Q4"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {toThousands} from "../../../../utils";

export default {
  name: "enterpriseNetworkTargetInformationEdit",
  props: {
    contractExpiryYear: {
      type: String,
      default: ""
    },
    partnerType: {
      type: String,
      default: ''
    },
    isSeniorEditor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        rebateCoefficient: void 0,
        // mboRebateRatio: void 0,
        assignment: void 0,
        saleTargetQ1: void 0,
        saleTargetQ2: void 0,
        saleTargetQ3: void 0,
        saleTargetQ4: void 0
      }
    };
  },
  watch: {
    // 渠道类型变化就清空
    partnerType(newValue) {
      if (newValue !== 'RAD') {
        this.formData.rebateCoefficient = void 0;
        this.formData.mboRebateRatio = void 0;
      }
    }
  },
  computed: {
    rules() {
      const validatorPercentage = (_, value, callback, __, ___, key) => {
        if (value === "") {
          return callback();
        }
        const percentageRegex = /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)%$/;
        if (!isNaN(value) && value >= 0 && value <= 100) {
          // 转换成百分数
          this.formData[key] = (value * 1).toFixed(2) + "%";
          callback();
        } else if (value && !percentageRegex.test(value)) {
          callback(new Error("Please enter the correct percentage"));
        } else {
          callback();
        }
      };

      return {
        rebateCoefficient: [
          {
            validator(...reset) {
              validatorPercentage(...reset, "rebateCoefficient");
            },
            message: "Please enter the correct percentage",
            trigger: "blur"
          }
        ],
        // mboRebateRatio: [
        //   {
        //     validator(...reset) {
        //       validatorPercentage(...reset, "mboRebateRatio");
        //     },
        //     message: "Please enter the correct percentage",
        //     trigger: "blur"
        //   }
        // ],
        saleTargetQ1: [
          {
            required: true,
            message: "Please enter saleTargetQ1",
            trigger: "blur"
          }
        ],
        saleTargetQ2: [
          {
            required: true,
            message: "Please enter saleTargetQ2",
            trigger: "blur"
          }
        ],
        saleTargetQ3: [
          {
            required: true,
            message: "Please enter saleTargetQ3",
            trigger: "blur"
          }
        ],
        saleTargetQ4: [
          {
            required: true,
            message: "Please enter saleTargetQ4",
            trigger: "blur"
          }
        ]
      };
    },
    assignment() {
      const {
        saleTargetQ1,
        saleTargetQ2,
        saleTargetQ3,
        saleTargetQ4
      } = this.formData;
      return (
        (saleTargetQ1 || 0) +
        (saleTargetQ2 || 0) +
        (saleTargetQ3 || 0) +
        (saleTargetQ4 || 0)
      );
    }
  },
  methods: {
    toThousands,
    getPercentageNumber(percentage) {
      if (!percentage && percentage !== '0.00%') {
        return void 0;
      }
      let number = Number(percentage.substring(0, percentage.length - 1));
      if (isNaN(number)) {
        return void 0;
      }
      return number / 100
    },
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(valid => {
        isPass = valid;
      });
      if (!isPass) return;
      return {
        ...JSON.parse(JSON.stringify(this.formData)),
        assignment: this.assignment,
        rebateCoefficient: this.getPercentageNumber(this.formData.rebateCoefficient) || 0,
        // mboRebateRatio: this.getPercentageNumber(this.formData.mboRebateRatio) || 0,
        mboRebateRatio: 0, // 不显示 不操作 送到后端默认0
        saleTargetQ1: this.formData.saleTargetQ1 || 0,
        saleTargetQ2: this.formData.saleTargetQ2 || 0,
        saleTargetQ3: this.formData.saleTargetQ3 || 0,
        saleTargetQ4: this.formData.saleTargetQ4 || 0
      };
    },
    setFormData(formData) {
      if (!formData) return;
      this.formData = JSON.parse(JSON.stringify(formData));
      this.$nextTick(() => {
        this.$refs.form.validateField(['rebateCoefficient']) // mboRebateRatio 隐藏 不做校验
      })
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/targetInformation/targetInformationEdit.vue